<template>
    <div class="container-fluid">
        <Breadcrumb title="Apply config to" v-bind:button-show="false"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12 row-preloader">
                <Preloader v-bind:class="{preloader: loading}" v-show="loading"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card">
                    <div class="card-body">
                        <AppliedPmtaConfigForm @hidePreloader="hidePreloader"></AppliedPmtaConfigForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '../components/Preloader';
    import AppliedPmtaConfigForm from './forms/AppliedPmtaConfigForm';
    import Breadcrumb from '../components/Breadcrumb';

    export default {
        name: 'AppliedPmtaConfig',
        components: {
            Preloader, AppliedPmtaConfigForm, Breadcrumb
        },
        data() {
            return {
                loading: false,
            }
        },
        mounted() {
        },
        computed: {
        },
        methods: {
            hidePreloader(value) {
                this.loading = value
            },
        }
    }
</script>

<style scoped>
</style>
